<template>
  <v-row>
    <v-col cols="12" md="4">
      <h3>Store name</h3>
      <p>Choose a name for your store</p>
    </v-col>
    <v-col cols="12" md="8">
      <v-text-field v-model="$parent.general.storeDetail.name"></v-text-field>
    </v-col>
    <v-col cols="12" md="4">
      <h3>Logo</h3>
      <p>Choose how to set your logo</p>
    </v-col>
    <v-col cols="12" md="8">
      <div>
        <v-radio-group v-model="$parent.logoOption" row>
          <v-radio label="Upload custom logo" value="upload"></v-radio>
          <v-radio label="Generate logo" value="default"></v-radio>
        </v-radio-group>
      </div>
      <div v-show="$parent.logoOption === 'upload'">
        <UploadOneImage :image="$parent.logoImage" @callback="getImageUpLoad" />
      </div>
      <div v-show="$parent.logoOption === 'default'">
        <GenerateLogo
          :name="nameLogo"
          @update:name="nameLogo = $event"
          @update:outputImage="$parent.outputImage = $event"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import UploadOneImage from '@/components/form/UploadOneImage.vue';
import GenerateLogo from '@/views/auth/components/generate-logo';

export default {
  components: { GenerateLogo, UploadOneImage },
  data() {
    return {
      nameLogo: this.$parent.general.storeDetail.name || 'My Logo',
    };
  },
  methods: {
    getImageUpLoad(image) {
      this.$parent.logoImage = image;
      this.$parent.attributes.logoPath = image.src;
      this.$forceUpdate();
    },
  },
};
</script>
